import React from 'react';
import { connect } from 'react-redux';
import { change, reduxForm } from 'redux-form';
import config from 'apex-web/lib/config';
import { buyValue, orderTypes } from 'apex-web/lib/constants/sendOrder/orderEntryFormConstants';
import { SIDE_PANES } from 'apex-web/lib/constants/sidePanesConstants';
import { convertIncrementToIntDecimalPlaces } from 'apex-web/lib/helpers/decimalPlaces/decimalPlacesHelper';
import { formatNumberToLocale } from 'apex-web/lib/helpers/numberFormatter';
import { getOrderFee, getOrderNet } from 'apex-web/lib/helpers/orderHelper';
import { openModal, MODAL_TYPES } from 'apex-web/lib/redux/actions/modalActions';
import { openSidePane } from 'apex-web/lib/redux/actions/sidePaneActions';
import { marketPriceOfSelectedInstrumentSelector } from 'apex-web/lib/redux/selectors/buySellSelectors';
import { selectedInstrumentSelector } from 'apex-web/lib/redux/selectors/instrumentPositionSelectors';
import { kycVerificationLevelsSelector } from 'apex-web/lib/redux/selectors/kycLevelsSelectors';
import { marginProductSelector } from 'apex-web/lib/redux/selectors/marginProductSelectors';
import { isMarginActiveSelector } from 'apex-web/lib/redux/selectors/marginSelectors';
import { orderTotalSelector } from 'apex-web/lib/redux/selectors/orderTotalSelector';
import { positionSelector } from 'apex-web/lib/redux/selectors/positionSelectors';
import { isBlockTradingEnabledForUser } from 'apex-web/lib/redux/selectors/userSelectors';
import VerificationRequiredContainer from 'apex-web/lib/components/VerificationRequired/VerificationRequiredContainer';
import OrderEntryAnchoring from './OrderEntryAnchoring';

const OrderEntryComponentForm = reduxForm({
  form: 'orderEntry',
  enableReinitialize: false,
  destroyOnUnmount: false,
  onSubmit: (payload, dispatch) => {
    dispatch(openModal(MODAL_TYPES.CONFIRM_ORDER_REPORT));
  }
})(OrderEntryAnchoring);

const mapStateToProps = state => {
  const { form } = state;
  const isMarginActive = isMarginActiveSelector(state);
  const marginProducts = marginProductSelector(state);
  let instrument = {};
  if (isMarginActive && !state.margin.instrument.fetching) {
    instrument = state.margin.instrument;
  } else {
    instrument = state.apexCore.instrument;
  }
  const { fetching } = instrument;
  const selectedInstrument = selectedInstrumentSelector(state);
  const selectedInstrumentId = selectedInstrument ? selectedInstrument.InstrumentId : 1;
  const level1 = state.apexCore.level1[selectedInstrumentId] || {};
  const orderEntryForm = form.orderEntry || { values: {} };
  const { disableTrading } = kycVerificationLevelsSelector(state);
  const orderTotal = form.orderEntry
    ? orderTotalSelector(state, { form: form.orderEntry.values })
    : 0;
  const positions = positionSelector(state);
  const marketPrice = marketPriceOfSelectedInstrumentSelector(state, {
    side: orderEntryForm.values.side
  });

  return {
    allowBlockTrading: isBlockTradingEnabledForUser(state),
    orderEntryForm,
    marketPrice,
    orderTotal: `${selectedInstrument.Product2Symbol} ${formatNumberToLocale(
      orderTotal,
      convertIncrementToIntDecimalPlaces(selectedInstrument.PriceIncrement)
    )}`,
    orderNet: getOrderNet(
      orderEntryForm,
      selectedInstrument,
      orderTotal,
      true,
      level1
    ),
    orderFee: getOrderFee(orderEntryForm, positions),
    initialValues: {
      side: orderEntryForm.values.side || buyValue,
      orderType: orderEntryForm.values.orderType || orderTypes.limit.displayName,
      quantity: '',
      value: '',
      limitPrice: '',
      stopPrice: '',
      fee: '0',
      totalAmount: '0',
      selectedInstrumentId,
      timeInForce: '1',
      anchoredField: ''
    },
    selectedInstrument,
    fetching,
    disableTrading,
    VerificationRequiredComponent: <VerificationRequiredContainer />,
    hideFees: !!config.global.hideFees,
    isMarginActive,
    marginProducts,
    positions,
    level1: state.apexCore.level1[selectedInstrumentId]
  };
};

const mapDispatchToProps = {
  reduxFormChange: (key, val) => change('orderEntry', key, val),
  openAdvancedOrderSidePane: () => openSidePane(SIDE_PANES.ADVANCED_ORDER),
  openReportBlockTradeSidePane: () => openSidePane(SIDE_PANES.REPORT_BLOCK_TRADE)
};

export default connect(mapStateToProps, mapDispatchToProps)(OrderEntryComponentForm);
